import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  DataProps,
  Gender,
  LookingGender,
} from "shared/components/Auth/RegistrationFormRedesign/types";
import RadioButton from "shared/components/Form/RadioButton";
import SpinLoader, {
  LOADER_COLOR_DARK,
  LOADER_SIZE_LARGE,
  POSITION_ABSOLUTE,
} from "shared/components/SpinLoader";

import { GENDER_FEMALE, GENDER_MALE } from "shared/constants";
import { MAN_OPEN_TO_MEN, WOMAN_OPEN_TO_MEN } from "shared/constants/profile";

type Props = {
  isModal: boolean;
  setData: React.Dispatch<React.SetStateAction<DataProps>>;
  setErrorGender: React.Dispatch<
    React.SetStateAction<{
      gender: string;
      lookingGender: string;
    }>
  >;
  errorGender: { gender: string; lookingGender: string };
  data: {
    gender: Gender;
    lookingGender?: LookingGender[];
  };
};

const FirstStep = ({
  isModal,
  setData,
  errorGender,
  data,
  setErrorGender,
}: Props) => {
  const { t, ready } = useTranslation("auth");
  const [loader, setLoader] = useState<boolean>(false);

  useEffect(() => {
    setLoader(!ready);
  }, [ready]);

  /**
   * Handler for choice user gender / looking gender
   */
  const handleSelectGender = (
    value: Gender | LookingGender,
    type: "gender" | "lookingGender"
  ) => {
    setErrorGender({ gender: "", lookingGender: "" });
    if (type === "gender") {
      setData((prev) => ({ ...prev, gender: value as Gender }));
    } else {
      setData((prev) => {
        const current = prev.lookingGender || [];
        const updated = current.includes(value as LookingGender)
          ? current.filter((gender) => gender !== value)
          : [...current, value as LookingGender];
        return { ...prev, lookingGender: updated };
      });
    }
  };

  return (
    <>
      {loader && (
        <SpinLoader
          color={LOADER_COLOR_DARK}
          size={LOADER_SIZE_LARGE}
          position={POSITION_ABSOLUTE}
          withBlur={true}
        />
      )}
      <span className="label_global">{t("IamLabel")}</span>
      <div className="gender_wrap">
        <RadioButton
          name={isModal ? "genderModal" : "gender"}
          label={t("redesignRegisterForm.manLabel")}
          id={isModal ? "radio1Modal" : "radio1"}
          value={GENDER_MALE}
          cb={(value: string) =>
            handleSelectGender(Number(value) as Gender, "gender")
          }
          isSelected={data.gender === GENDER_MALE}
          isForm={true}
          customClass="cupidlee"
        />
        <RadioButton
          name={isModal ? "genderModal" : "gender"}
          label={t("redesignRegisterForm.womanLabel")}
          id={isModal ? "radio2Modal" : "radio2"}
          value={GENDER_FEMALE}
          cb={(value: string) =>
            handleSelectGender(Number(value) as Gender, "gender")
          }
          isSelected={data.gender === GENDER_FEMALE}
          isForm={true}
          customClass="cupidlee"
        />
      </div>
      {!errorGender.gender && (
        <p className="error__redesign">{errorGender.gender}</p>
      )}
      <span className="label_global">{t("lookingLabel")}</span>
      <div className="gender_wrap">
        <RadioButton
          name={isModal ? "lookingGenderModal" : "lookingGender"}
          label={t("redesignRegisterForm.womanLabel")}
          id={isModal ? "radio3Modal" : "radio3"}
          value={WOMAN_OPEN_TO_MEN}
          cb={() => handleSelectGender(WOMAN_OPEN_TO_MEN, "lookingGender")}
          isSelected={data.lookingGender?.includes(WOMAN_OPEN_TO_MEN)}
          isForm={true}
          customClass="cupidlee"
          type="checkbox"
        />

        <RadioButton
          name={isModal ? "lookingGenderModal" : "lookingGender"}
          label={t("redesignRegisterForm.manLabel")}
          id={isModal ? "radio4Modal" : "radio4"}
          value={MAN_OPEN_TO_MEN}
          cb={() => handleSelectGender(MAN_OPEN_TO_MEN, "lookingGender")}
          isSelected={data.lookingGender?.includes(MAN_OPEN_TO_MEN)}
          isForm={true}
          customClass="cupidlee"
          type="checkbox"
        />
      </div>
      {errorGender.lookingGender && (
        <p className="error__redesign">{errorGender.lookingGender}</p>
      )}
    </>
  );
};

export default FirstStep;
